// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"xP-z","carousel":"yP-z"};